/**
 * Live lessons spec section 5: a slot can be booked no later than the lead
 * time before it starts and at most 14 days ahead. The server owns the lead
 * time (LIVE_MIN_LEAD_MINUTES, rules.ts bookMinLeadMinutes) and sends it as
 * bookingWindow.minMinutesBefore in getLiveBookingContext; the client reads
 * it from there. 120 is only for a response without the field. Keep
 * LIVE_CALL_MAX_DAYS_AHEAD in step with BOOK_MAX_DAYS_AHEAD there.
 */
export const LIVE_CALL_MAX_DAYS_AHEAD = 14;

/** The lead time when the server's response does not carry minMinutesBefore. */
const LEAD_MINUTES_IF_MISSING = 120;

/** The server's lead time, or 120 when the field is missing. */
export function leadMinutesOf(window: { minMinutesBefore?: number | null } | null | undefined): number {
  const v = window?.minMinutesBefore;
  return typeof v === 'number' && Number.isFinite(v) && v >= 0 ? v : LEAD_MINUTES_IF_MISSING;
}

export function bookingWindowFrom(
  now: Date, minMinutesBefore: number = LEAD_MINUTES_IF_MISSING,
): { earliestStartAt: string; latestStartAt: string } {
  return {
    earliestStartAt: new Date(now.getTime() + minMinutesBefore * 60_000).toISOString(),
    latestStartAt: new Date(now.getTime() + LIVE_CALL_MAX_DAYS_AHEAD * 24 * 3_600_000).toISOString(),
  };
}

/** Whether a slot starting at `startAt` can be booked now, with the server's lead time. */
export function inBookingWindow(startAt: string, now: Date, minMinutesBefore?: number): boolean {
  const w = bookingWindowFrom(now, minMinutesBefore);
  const t = new Date(startAt).getTime();
  return t >= new Date(w.earliestStartAt).getTime() && t <= new Date(w.latestStartAt).getTime();
}
